import { FC } from "react";
import { useFormContext } from "react-hook-form";

// Utilities
import { roundNumber } from "@/_helpers/number_functions";

// Interfaces
import { IRecipeBuilder } from "@/interfaces/recipe/recipe_builder";

// Components
import NumberInput from "@/components/number_input";


interface _PortionInputProps {
    ingredientIndex: number;
    readonly: boolean;
}

const PortionInput: FC<_PortionInputProps> = ({ 
    ingredientIndex,
    readonly
}) => {

    const { control, setValue, getValues } = useFormContext<IRecipeBuilder>();

    const handlePortionChange = (portion: number) => {
        setValue(`ingredients.${ingredientIndex}.amount`, portion);
        const ingredients = getValues('ingredients')

        const protein = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.protein / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);
        const carbs = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.carbs / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);
        const fat = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.fat / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);
        const fibre = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.fibre / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);
        const alcohol = roundNumber(ingredients.reduce((acc, ingredient) => {
            return acc + (ingredient.macros.alcohol / 100) * (ingredient.amount * ingredient.unit.weight)
        }, 0), 1);

        setValue('calories', protein * 4 + carbs * 4 + fat * 9);
        setValue('protein', protein);
        setValue('carbs', carbs);
        setValue('fat', fat);
        setValue('fibre', fibre);
        setValue('alcohol', alcohol);
    };

    
    return (
        <NumberInput
            name={`ingredients.${ingredientIndex}.amount`}
            control={control}
            maxLength={3}
            decimalPlaces={2}
            placeHolder="0"
            hideErrorMessage
            gutter="0"
            disabled={readonly}
            onChange={handlePortionChange}
        />
    )
}

export default PortionInput;